export enum EnvironmentLinkEnum {
  PRODUCTION = 'https://s3.amazonaws.com/assets.readingcritters.com/app-configs/production/environment.json',
  INTEGRATION = 'https://s3.amazonaws.com/assets.int.readingcritters.com/app-configs/{{ENVIRONMENT}}/environment.json',
}
